import { render, staticRenderFns } from "./riwayat.vue?vue&type=template&id=f660e0f8"
import script from "./riwayat.vue?vue&type=script&lang=js"
export * from "./riwayat.vue?vue&type=script&lang=js"
import style0 from "./riwayat.vue?vue&type=style&index=0&id=f660e0f8&prod&lang=css"
import style1 from "./riwayat.vue?vue&type=style&index=1&id=f660e0f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports